// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3198) return "static/chunks/3198.d5f87c4ca733101a.js";
	if (chunkId === 1151) return "static/chunks/f3e74005.1613f8208ec0d51f.js";
	if (chunkId === 8049) return "static/chunks/8049.310de08269b957cf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"4614":"185aa36bebb0a388","5048":"ad8f9fd334f26a81","5659":"1c6d0619b9ac7186","5906":"aa1e7f1f2231c0c6","8726":"866146607cf0b4d7"}[chunkId] + ".js";
};